<form (submit)="creer($event)" [attr.aria-busy]="envoi()">
  <header>
    <span class="dialog-icon material-symbols-outlined" aria-hidden="true">create_new_folder</span>
    <div>
      <h2 id="creer-parc-titre">Créer un nouveau parc</h2>
      <p id="creer-parc-description">Regroupez les installations à superviser dans un même parc.</p>
    </div>
    <button class="fermer" type="button" aria-label="Fermer" [disabled]="envoi()" (click)="fermer()">
      <span class="material-symbols-outlined" aria-hidden="true">close</span>
    </button>
  </header>

  <div class="contenu">
    <fieldset [disabled]="envoi()">
      <label for="parc-libelle">Libellé du parc <span aria-hidden="true">*</span></label>
      <input id="parc-libelle" [formField]="formulaire.libelle" placeholder="Ex. Parc Occitanie"
        autocomplete="off" aria-describedby="parc-libelle-aide" />
      <p id="parc-libelle-aide" class="aide">Obligatoire · 100 caractères maximum.</p>

      <div class="selection-entete">
        <span id="parc-installations-label">Installations <span aria-hidden="true">*</span></span>
        <span class="compteur" role="status">{{ selection().size }} sélectionnée{{ selection().size > 1 ? 's' : '' }}</span>
      </div>
      <label class="sr-only" for="parc-recherche">Rechercher une installation</label>
      <div class="recherche">
        <input #rechercheInput id="parc-recherche" type="search" placeholder="Rechercher une installation"
          [value]="recherche()" (input)="recherche.set(rechercheInput.value)" />
        <span class="material-symbols-outlined" aria-hidden="true">search</span>
      </div>

      @if (chargement()) {
        <p class="etat" role="status">Chargement des installations…</p>
      } @else if (erreurChargement()) {
        <div class="etat">
          <p class="erreur" role="alert">{{ erreurChargement() }}</p>
          <button type="button" (click)="chargerInstallations()">Réessayer</button>
        </div>
      } @else {
        <div class="installations" role="group" aria-labelledby="parc-installations-label" aria-describedby="parc-selection-aide">
          @for (installation of installationsFiltrees(); track installation.id) {
            <label class="installation">
              <input type="checkbox" [checked]="selection().has(installation.id)"
                (change)="basculerInstallation(installation.id)" />
              <span>{{ installation.nom }}</span>
            </label>
          } @empty {
            <p class="vide">{{ installations().length ? 'Aucune installation ne correspond à la recherche.' : 'Aucune installation disponible.' }}</p>
          }
        </div>
      }
      <p id="parc-selection-aide" class="aide">Sélectionnez au moins une installation.</p>
    </fieldset>
    @if (erreur()) { <p class="erreur" role="alert">{{ erreur() }}</p> }
  </div>

  <footer>
    <button type="button" [disabled]="envoi()" (click)="fermer()">Annuler</button>
    <button type="submit" class="creer" [disabled]="!peutCreer()">
      <span class="material-symbols-outlined" aria-hidden="true">check</span>
      {{ envoi() ? 'Création en cours…' : 'Créer le parc' }}
    </button>
  </footer>
</form>
